import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ModuleFlowService {
  private readonly STORAGE_KEY = 'prism_popupPassed';
  private fallbackFlag = false;

  passPopup(): void {
    this.fallbackFlag = true;
    try {
      sessionStorage.setItem(this.STORAGE_KEY, 'true');
    } catch { }
  }

  reset(): void {
    this.fallbackFlag = false;
    try {
      sessionStorage.removeItem(this.STORAGE_KEY);
    } catch { }
  }

  hasPassedPopup(): boolean {
    try {
      return sessionStorage.getItem(this.STORAGE_KEY) === 'true';
    } catch {
      return this.fallbackFlag;
    }
  }
}
